__turbopack_context__.v({
  "alert": "ow4TpW_alert",
  "alert__button-icon": "ow4TpW_alert__button-icon",
  "alert__close-button": "ow4TpW_alert__close-button",
  "alert__close-button-wrapper": "ow4TpW_alert__close-button-wrapper",
  "alert__content": "ow4TpW_alert__content",
  "alert__content--stacked": "ow4TpW_alert__content--stacked",
  "alert__heading": "ow4TpW_alert__heading",
  "alert__icon": "ow4TpW_alert__icon",
  "alert__message": "ow4TpW_alert__message",
  "alert__variant": "ow4TpW_alert__variant",
  "alert__variant--error": "ow4TpW_alert__variant--error",
  "alert__variant--informational": "ow4TpW_alert__variant--informational",
  "alert__variant--success": "ow4TpW_alert__variant--success",
});
